// import { Container } from './styles';
import { useCallback, useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import Logo from "../../../../../../../../../assets/images/logo-sulog-rodape.svg";

import Loading from "../../../../../../../../../core/common/Loading";
import {
  formatDateTimeBR,
  renderCargoTypes,
  renderPaymentTypes,
  renderVehicleTypes,
} from "../../../../../../../../../helpers/format";
import api from "../../../../../../../../../services/api";
import { IPaymentTicket } from "../types/types";

interface Props {
  data: any;
  numPages?: number;
  onClose: () => void;
}

const Ticket = (_props: Props) => {
  const [dataTicket, setDataTicket] = useState<IPaymentTicket[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const printRef: any = useRef(null);

  const handlePrint = () => {
    print();
  };

  const print = useReactToPrint({
    contentRef: printRef,
  });

  const getPaymentTicket = useCallback(async () => {
    try {
      setLoading(true);

      let currentRow: any = localStorage.getItem("@triagem");

      if (currentRow) {
        currentRow = JSON.parse(currentRow);
      }

      const body = {
        id_operacao_patio:
          Number(localStorage.getItem("id_operacao_patio")) ||
          Number(currentRow.id_operacao_patio),
      };

      const response = await api.post("/operacaopatio/custoOperacao", body);

      if (response.status === 200) {
        let rows: IPaymentTicket[] = [];
        var numPages = 3;
        for (var i = 0; i < numPages; i++) {
          rows.push(response.data);
        }
        setDataTicket(rows);

        setTimeout(() => {
          handlePrint();
        }, 1000);

        setLoading(false);
      }
    } catch {
      setLoading(false);
    }
    // Sem dependência em props.data: se o pai passar uma nova referência a cada
    // render, este callback mudaria a cada render e o useEffect abaixo entraria
    // em loop de re-render (React error #185 - "Maximum update depth exceeded").
  }, []);

  const didFetchRef = useRef(false);

  useEffect(() => {
    if (didFetchRef.current) return;
    didFetchRef.current = true;
    getPaymentTicket();
  }, [getPaymentTicket]);

  return (
    <>
      <Loading loading={loading} skeletonVariant="card" skeletonFields={10} skeletonFooterButtons={0} />
      <div
        ref={printRef}
        className="w-[300px] h-full bg-[#FFF] p-1 ml-2 mt-4"
        id="ticket"
      >
        {dataTicket.length > 0 &&
          dataTicket.map((item: IPaymentTicket) => {
            const op = item.operacaoPatio;
            const payments = op?.pagamento || [];
            const activePayments = payments.filter((p: any) => Number(p.status) === 0 || p.status === undefined);
            const hasFaturadoPayment = activePayments.some((p: any) => p.tipo_pagamento === 3 || p.tipo_pagamento === "3");

            const transportadora = (item as any).transportadora ||
                                   op?.operacao_porto_carrossel?.transportadora || 
                                   op?.operacao_porto_agendada?.transportadora || 
                                   op?.transportadora;

            const isTriagemFaturada = hasFaturadoPayment && transportadora && (transportadora.faturamento_triagem === 1 || transportadora.faturamento_triagem === true || transportadora.faturamento_triagem === "1");
            const isEstadiaFaturada = hasFaturadoPayment && transportadora && (transportadora.faturamento_estadia === 1 || transportadora.faturamento_estadia === true || transportadora.faturamento_estadia === "1");

            const is100PercentFaturado = (isTriagemFaturada && isEstadiaFaturada) || op?.operacao_porto_carrossel !== null;

            const avulsoPayments = activePayments.filter((p: any) => p.tipo_pagamento !== 3 && p.tipo_pagamento !== "3");
            const valorPagoAvulso = avulsoPayments.length > 0
              ? avulsoPayments.reduce((sum: number, p: any) => sum + Number(p.quantia_paga || 0), 0)
              : (isTriagemFaturada && !isEstadiaFaturada
                  ? ((item.valor_total_estadia || 0) + (item.valor_hora_extra || 0))
                  : (isEstadiaFaturada && !isTriagemFaturada
                      ? (item.valor_total_triagem || 0)
                      : item.valor_pago));

            return (
              <div
                className="w-full h-full p-2 flex flex-col items-center justify-center"
                style={{ pageBreakAfter: "always" }}
              >
              <div className="w-full h-full flex flex-col items-center justify-center">
                <img src={Logo} width={140} height={140} />
                <div className="w-full flex items-center justify-center mt-3">
                  <h1 className="text-sm text-[#000] font-bold mr-1">CNPJ:</h1>
                  <span className="text-sm text-[#000] font-bold">
                    11.166.491/0001-61
                  </span>
                </div>
              </div>

              <div
                className="w-full flex flex-col items-center justify-center mt-2 p-4"
                style={{ borderBottom: "2px dashed #000" }}
              >
                {item.operacaoPatio.operacao_porto_carrossel !== null ? (
                  <span className="text-sm text-[#000] font-bold">
                    Carrossel
                  </span>
                ) : (
                  <>
                    <span className="text-sm text-[#000] font-bold">
                      Agendamento:
                    </span>
                    <span className="text-sm text-[#000] font-bold mt-1">
                      {item.operacaoPatio.operacao_porto_agendada !== null
                        ? formatDateTimeBR(
                          item.operacaoPatio.operacao_porto_agendada
                            .data_agendamento_terminal
                        )
                        : "---"}
                    </span>
                  </>
                )}
              </div>
              <div
                className="w-full flex flex-col items-center justify-center p-4"
                style={{ borderBottom: "2px dashed #000" }}
              >
                <span className="text-sm text-[#000] font-bold">
                  Motorista:
                </span>
                <span className="text-sm text-[#000] font-bold mt-1">
                  {item.motorista !== null ? item.motorista.nome : "---"}
                </span>
              </div>
              <div
                className="w-full flex flex-col items-center justify-center mt-3 p-4"
                style={{ borderBottom: "2px dashed #000" }}
              >
                <div className="w-full flex items-center mb-1">
                  <span className="text-sm text-[#000] font-bold">
                    Tipo do Veículo:
                  </span>
                  <span className="text-sm text-[#000] font-normal ml-1">
                    {item.operacaoPatio.operacao_patio_identificacao_veiculo &&
                      item.operacaoPatio.operacao_patio_identificacao_veiculo !==
                      null
                      ? renderVehicleTypes(
                        item.operacaoPatio
                          .operacao_patio_identificacao_veiculo.tipo_veiculo
                      )
                      : "---"}
                  </span>
                </div>
                <div className="w-full flex items-center mb-1">
                  <span className="text-sm text-[#000] font-bold">Placa:</span>
                  <span className="text-sm text-[#000] font-normal ml-1">
                    {item.veiculo !== null ? item.veiculo.placa : "---"}
                  </span>
                </div>
                <div className="w-full flex items-center mb-1">
                  <span className="text-sm text-[#000] font-bold">
                    Transportadora:
                  </span>
                  <span className="text-sm text-[#000] font-normal ml-1">
                    {(() => {
                      const op = item.operacaoPatio;
                      const transportadora = op.operacao_porto_carrossel?.transportadora || 
                                           op.operacao_porto_agendada?.transportadora || 
                                           op.transportadora;
                      
                      if (!transportadora) return "---";
                      if (typeof transportadora === 'object') {
                        return transportadora.razao_social || transportadora.nome || transportadora.nome_fantasia || "---";
                      }
                      return transportadora;
                    })()}
                  </span>
                </div>
                <div className="w-full flex items-center mb-1">
                  <span className="text-sm text-[#000] font-bold">
                    Terminal:
                  </span>
                  <span className="text-sm text-[#000] font-normal ml-1">
                    {item.operacaoPatio.id_operacao_porto_carrossel !== null ? (
                      <>
                        {item.operacaoPatio.id_operacao_porto_carrossel !== null &&
                          item.operacaoPatio.operacao_porto_carrossel.terminal !== null
                          ? item.operacaoPatio.operacao_porto_carrossel.terminal
                            .razao_social
                          : "---"}
                      </>
                    ) : (
                      <>
                        {item.operacaoPatio.operacao_porto_agendada !== null &&
                          item.operacaoPatio.operacao_porto_agendada.terminal !== null
                          ? item.operacaoPatio.operacao_porto_agendada.terminal
                            .razao_social
                          : "---"}
                      </>
                    )}
                  </span>
                </div>
                <div className="w-full flex items-center mb-1">
                  <span className="text-sm text-[#000] font-bold">
                    Tipo Carga:
                  </span>
                  <span className="text-sm text-[#000] font-normal ml-1">
                    {item.operacaoPatio.operacao_porto_agendada !== null &&
                      item.operacaoPatio.operacao_porto_agendada.tipo_carga !==
                      null
                      ? renderCargoTypes(
                        item.operacaoPatio.operacao_porto_agendada.tipo_carga
                      ).replace(",", "")
                      : "---"}
                  </span>
                </div>
                <div className="w-full flex items-center mb-1">
                  <span className="text-sm text-[#000] font-bold">
                    Número Container:
                  </span>
                  <span className="text-sm text-[#000] font-normal ml-1">
                    {item.operacaoPatio.operacao_porto_agendada !== null &&
                      item.operacaoPatio.operacao_porto_agendada
                        .identificadores_conteineres !== null
                      ? item.operacaoPatio.operacao_porto_agendada
                        .identificadores_conteineres
                      : "---"}
                  </span>
                </div>

              </div>
              <div
                className="w-full flex flex-col items-center justify-center mt-3 p-4"
                style={{ borderBottom: "2px dashed #000" }}
              >
                <div className="w-full flex items-center mb-1">
                  <span className="text-sm text-[#000] font-bold">
                    Entrada:
                  </span>
                  <span className="text-sm text-[#000] font-normal ml-1">
                    {item.operacaoPatio.entrada_veiculo !== null
                      ? formatDateTimeBR(
                        item.operacaoPatio.entrada_veiculo.data_hora
                      )
                      : "---"}
                  </span>
                </div>
                <div className="w-full flex items-center mb-1">
                  <span className="text-sm text-[#000] font-bold">
                    Pagamento:
                  </span>
                  <span className="text-sm text-[#000] font-normal ml-1">
                    {activePayments.length > 0
                      ? activePayments
                        .map((item: any) =>
                          formatDateTimeBR(item.data_hora_pagamento)
                        )
                        .join(",")
                      : "---"}
                  </span>
                </div>
                <div className="w-full flex items-center mb-1">
                  <span className="text-sm text-[#000] font-bold">
                    Tempo de Permanência:
                  </span>
                  <span className="text-sm text-[#000] font-normal ml-1">
                    {item.tempo_permanencia !== null
                      ? item.tempo_permanencia
                      : "---"}
                  </span>
                </div>
                <div className="w-full flex items-center mb-1">
                  <span className="text-sm text-[#000] font-bold">
                    Qtd. de Horas Extras:
                  </span>
                  <span className="text-sm text-[#000] font-normal ml-1">
                    {item.qtd_horas_extras !== null
                      ? item.qtd_horas_extras
                      : "---"}
                  </span>
                </div>
              </div>
              <div
                className="w-full flex flex-col items-center justify-center mt-3 p-4"
                style={{ borderBottom: "2px dashed #000" }}
              >
                {is100PercentFaturado ? (
                  <></>
                ) : (
                  <>
                    <div className="w-full flex items-center justify-between mb-1">
                      <span className="text-sm text-[#000] font-bold">
                        Triagem:
                      </span>
                      <div
                        className="w-full ml-2 mr-2"
                        style={{ border: "1px dashed #ccc" }}
                      />
                      <span className="text-sm text-[#000] font-bold ml-1 w-full text-right">
                        {isTriagemFaturada ? (
                          "FATURADO"
                        ) : (
                          item.valor_total_triagem.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        )}
                      </span>
                    </div>
                    {item.valor_hora_extra > 0 && (
                      <div className="w-full flex items-center justify-between mb-4">
                        <span className="text-sm text-[#000] font-bold">
                          Hora Extra:
                        </span>
                        <div
                          className="w-full ml-2 mr-2"
                          style={{ border: "1px dashed #ccc" }}
                        />
                        <span className="text-sm text-[#000] font-bold ml-1 w-full text-right">
                          {isEstadiaFaturada ? (
                            "FATURADO"
                          ) : (
                            item.valor_hora_extra.toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })
                          )}
                        </span>
                      </div>
                    )}
                    <div className="w-full flex items-center justify-between mb-4">
                      <span className="text-sm text-[#000] font-bold">
                        Estadia:
                      </span>
                      <div
                        className="w-full ml-2 mr-2"
                        style={{ border: "1px dashed #ccc" }}
                      />
                      <span className="text-sm text-[#000] font-bold ml-1 w-full text-right">
                        {isEstadiaFaturada ? (
                          "FATURADO"
                        ) : (
                          item.valor_total_estadia.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        )}
                      </span>
                    </div>
                    <div className="w-full flex items-center justify-between mb-1">
                      <span className="w-[70%] text-sm text-[#000] font-bold">
                        Valor Pago:
                      </span>
                      <div
                        className="w-full ml-2 mr-2"
                        style={{ border: "1px dashed #ccc" }}
                      />
                      <span className="text-sm text-[#000] font-bold ml-1 w-full text-right">
                        {valorPagoAvulso.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </span>
                    </div>

                  </>
                )}

                <div className="w-full flex flex-col items-center justify-between mb-1">
                  <span className="text-sm text-[#000] font-bold">
                    Tipo de pagamento:
                  </span>
                  {is100PercentFaturado ? (
                    <span className="text-sm text-[#000] font-bold ml-1 flex flex-col">
                      FATURADO
                    </span>
                  ) : activePayments.filter((p: any) => p.tipo_pagamento !== 3 && p.tipo_pagamento !== "3").length > 0 ? (
                    <>
                      {activePayments
                        .filter((p: any) => p.tipo_pagamento !== 3 && p.tipo_pagamento !== "3")
                        .map((p: any) => (
                          <span className="text-sm text-[#000] font-bold ml-1 flex flex-col" key={p.id_operacao_patio_pagamento}>
                            {renderPaymentTypes(p.tipo_pagamento)}
                          </span>
                        ))}
                    </>
                  ) : (
                    "---"
                  )}
                </div>
              </div>

              <div className="w-full flex flex-col items-center justify-center mt-3 p-4">
                <div className="w-full flex items-center justify-between mb-1">
                  <span className="text-sm text-[#000] font-bold">
                    Operador:
                  </span>
                  <span className="text-sm text-[#000] font-bold ml-1 w-full">
                    {
                      // Busca o nome do usuário do último pagamento ativo, se existir
                      activePayments.length > 0 && activePayments[activePayments.length - 1]?.usuario
                        ? activePayments[activePayments.length - 1].usuario.toUpperCase()
                        : "ADMINISTRADOR"
                    }
                  </span>
                </div>

                <div className="mt-6">
                  <span className="max-w-[50%] text-base text-wrap text-[#000] font-bold">
                    DOCUMENTO SEM VALOR FISCAL
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default Ticket;
